import {Injectable} from '@angular/core';
import {Preferences} from '@capacitor/preferences';
import {StorageKey} from '../../enums/storage-key';

/**
 * @deprecated
 */
@Injectable({
  providedIn: "root",
})
export class OldStorageService {
  public async get(storageKey: StorageKey): Promise<any> {
    const { value } = await Preferences.get({ key: storageKey });

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  // public async set(storageKey: StorageKey, value: any): Promise<void> {
  //   const stringValue: string = JSON.stringify(value);
  //
  //   await Preferences.set({ key: storageKey, value: stringValue });
  // }

  public async remove(storageKey: StorageKey): Promise<void> {
    await Preferences.remove({ key: storageKey });
  }
}
